import rootReducer from './reducers';
import { configureStore } from '@reduxjs/toolkit';
export const store = configureStore({
    reducer: rootReducer
});
// store.subscribe(() => {
//     console.log(store.getState())
// });